/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventemailssettinghint3Inputs */

const en_eventemailssettinghint3 = /** @type {(inputs: Eventemailssettinghint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A recap with the key numbers the morning after an event, and a short note when an event gets a lot of views.`)
};

const de_eventemailssettinghint3 = /** @type {(inputs: Eventemailssettinghint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Morgen nach einem Event ein Rückblick mit den wichtigsten Zahlen, dazu eine kurze Nachricht, wenn ein Event viele Aufrufe bekommt.`)
};

/**
* | output |
* | --- |
* | "A recap with the key numbers the morning after an event, and a short note when an event gets a lot of views." |
*
* @param {Eventemailssettinghint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventemailssettinghint3 = /** @type {((inputs?: Eventemailssettinghint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventemailssettinghint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventemailssettinghint3(inputs)
	return de_eventemailssettinghint3(inputs)
});
export { eventemailssettinghint3 as "eventEmailsSettingHint" }